import { EEthereumNetworkId } from '@ankr.com/provider';

import { AutomateApi } from 'modules/api';
import { api, cacheTags } from 'modules/store';

export interface GetApiTaskResult {
  taskId: string;
  name: string;
  cronDate: string;
  cronTarget: string;
  funcName: string;
  params: string[];
}

export const {
  useGetApiTaskQuery,
  endpoints: { getApiTask },
} = api.injectEndpoints({
  endpoints: build => ({
    getApiTask: build.query<
      GetApiTaskResult | null,
      { taskId: string; chainId: EEthereumNetworkId | null }
    >({
      queryFn: async ({ taskId, chainId }) => {
        if (!taskId || !chainId) {
          return { data: null };
        }

        const api = new AutomateApi(chainId);
        const {
          name,
          funcName,
          cronDate,
          cronTarget,
          params = [],
        } = await api.getTask(taskId);

        return {
          data: {
            taskId,
            name,
            funcName,
            params,
            cronDate,
            cronTarget,
          },
        };
      },
      providesTags: [cacheTags.taskData],
    }),
  }),
});
